import { render } from "./PolicyIcon.vue?vue&type=template&id=03ad424f&ts=true"
import script from "./PolicyIcon.vue?vue&type=script&lang=ts"
export * from "./PolicyIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__